const LivechatGame = () => {
  return (
    <div
      className="conversation-message-bubble"
      style={{
        maxWidth: 700,
        width: "100%",
        height: 400,
        padding: 0,
      }}
    >
      <iframe
        title="Derby Game"
        src="https://media.boyslife.org/onlinegames/nitroderby/"
        width="100%"
        height="100%"
      />
    </div>
  );
};

export default LivechatGame;
